// assets
import { RadarChartOutlined, GlobalOutlined } from "@ant-design/icons";
import Permissions from "constants/Permissions";

// ==============================|| MENU ITEMS - CROWDSOURCE ||============================== //

const crowdsource = {
    id: "group-crowdsourcing",
    title: "Crowdsourcing",
    type: "group",
    appModule: "CROWDSOURCING",
    children: [
        {
            id: "threat-monitoring",
            title: "Threat Monitoring",
            authority: Permissions.CrowdsourceSection.ThreatMonitor,
            type: "item",
            url: "/threat-monitor",
            icon: RadarChartOutlined,
            breadcrumbs: false,
        },
        {
            id: "bellingcat-events",
            title: "Bellingcat Events",
            authority: Permissions.CrowdsourceSection.ThreatMonitor,
            type: "item",
            url: "/bellingcat-events",
            icon: GlobalOutlined,
            breadcrumbs: false,
        },
    ],
};

export default crowdsource;
